/**
 * Dimensions.
 */
export const sSize = '1.2rem';
export const msSize = '1.4rem';
export const mSize = '1.6rem';
export const mlSize = '2.0rem';
export const mllSize = '2.4rem';
export const lSize = '3.2rem';
export const xlSize = '4.8rem';

export const breakpoints = {
  desktop: '45rem',
};

export const widths = {
  leftBar: 50,
  explorer: 200,
};

export const heights = {
  navBar: 40,
  statusBar: 22,
};
